/* eslint-disable import/prefer-default-export */

import axios from 'axios';
import { camelizeKeys } from 'humps';

export function getKsEmailTemplates() {
  return axios
    .get('/api/v1/ks/email_templates')
    .then(res => camelizeKeys(res.data.data));
}

export function updateKsTemplate(params) {
  return axios
    .patch(`/api/v1/ks/email_templates/category/${params.category}`, params)
    .then(res => camelizeKeys(res.data));
}

export function createKsTemplate(params) {
  return axios
    .post('/api/v1/ks/email_templates/create', params)
    .then(res => camelizeKeys(res.data));
}

export function changeKsStateTemplate(category) {
  return axios
    .patch(`/api/v1/ks/email_templates/change_state/${category}`)
    .then(res => camelizeKeys(res.data));
}
